var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-simple-table',{attrs:{"header":"0","rows":_vm.rows,"cols":_vm.cols,"vertical-align":"top"}})
}
var staticRenderFns = []

export { render, staticRenderFns }